
import { useQuery } from 'react-query';
import { useContext } from 'react';
import { AuthContext } from '../Context/AuthContext';

const useOpenMessagesCount = () => {
  const { token } = useContext(AuthContext);

  const fetchOpenMessagesCount = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/publicmsgs/total-open-tickets`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error('Failed to fetch data');
      }
 

      const data = await response.json();
      return data.openTicketCount;
    } catch (error) {
      throw new Error('Failed to fetch data');
    }
  };

  const { data: openMessageCount, isLoading, isError } = useQuery('openMessageCount', fetchOpenMessagesCount);

  return { openMessageCount, loading: isLoading, error: isError };
};

export default useOpenMessagesCount;